import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../Redux/Actions/AuthActions';
import logo from "../image/LOGKDO+.png";
import './Login.css';
// Import NavAuth css to inherit base variables & container styles
import './NavAuth.css';

const Login = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [matricule, setMatricule] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = (a) => {
    a.preventDefault();
    dispatch(login({ email, password, matricule }, navigate));
  };

  return (
    // Reuse dashboard-container for the same gradient background
    <div className="dashboard-container justify-content-center">

      <div className="login-form-container">

        {/* LOGO & TITLE HEADER */}
        <div className="login-title-section">
          <Link to="/Welcome">
            <img src={logo} alt="Logo" className="brand-logo" style={{ height: '70px', marginTop: '-40px' }} />
          </Link>
          <h2 className="login-title">Connexion Admin</h2>
          <p className="login-subtitle">Accédez à votre espace de gestion</p>
        </div>

        <Form onSubmit={handleLogin}>

          {/* MATRICULE INPUT */}
          <Form.Group className="mb-4">
            <Form.Label className="form-label-premium">Matricule</Form.Label>
            <Form.Control
              onChange={(e) => setMatricule(e.target.value)}
              type="text"
              placeholder="Entrez votre matricule"
              value={matricule}
              className="input-premium"
            />
          </Form.Group>

          {/* EMAIL INPUT */}
          <Form.Group className="mb-4">
            <Form.Label className="form-label-premium">Adresse Email</Form.Label>
            <Form.Control
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="exemple@etudesfinancieres.com"
              value={email}
              className="input-premium"
            />
          </Form.Group>

          {/* PASSWORD INPUT */}
          <Form.Group className="mb-4">
            <Form.Label className="form-label-premium">Mot de passe</Form.Label>
            <Form.Control
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="••••••••"
              value={password}
              className="input-premium"
            />
          </Form.Group>

          {/* SUBMIT BUTTON */}
          <Button variant="primary" type="submit" className="w-100 btn-premium">
            Se Connecter
          </Button>

          {/* BACK LINK */}
          <Link to="/Welcome" className="back-link">
            ← Retour à l'accueil
          </Link>

        </Form>
      </div>
    </div>
  );
};

export default Login;
